//Node Modules
import { useRecoilValueLoadable } from "recoil";
import { Trans } from "react-i18next";

//BinaryForge Components
import { AnalyticsChart } from "./";
import { Loading, Note } from "../helpers";

//Atoms
import { pinnedReportDataSelector } from "../../atoms/dashboard";

//Chart for a single pinned report
const PinnedReportChart = ({ report }) => {
	const { state, contents } = useRecoilValueLoadable(pinnedReportDataSelector(report));

	switch (state) {
		case "hasError":
			return (
				<Note
					messageKey={`Error: ${contents.message ? contents.message : contents}`}
					icon="pi-exclamation-circle fontColour-error"
				/>
			);
		case "loading":
			return <Loading />;
		case "hasValue":
			if (!contents || contents.errors) {
				return (
					<Note
						messageKey={
							<Trans
								i18nKey="report.preset.dataExceeded"
								components={{ ul: <ul />, li: <li /> }}
								context="HISTORICAL"
							/>
						}
						icon="pi-exclamation-triangle fontColour-warn"
					/>
				);
			}
			return <AnalyticsChart analyticsData={contents.chart} timestamps={contents.timestamp} />;
		default:
			return null;
	}
};

export default PinnedReportChart;
